import React from 'react';
import PartnerSection from '../PartnerSection';
import Bg from '../../images/shapes/bg_pattern_1.svg'


const FeaturesSection = (props) => {

    return (
        <section className="client_logo_section section_space" style={{ backgroundImage: `url(${Bg})` }}>
            <div className="container">
                <div className="section_space pt-0 pb-0">
                    <div className="heading_block text-center">
                        <div className="heading_focus_text mb-0">
                            <span className="badge bg-secondary text-white">Technologies</span>
                            We Work With
                        </div>
                    </div>
                    <PartnerSection />
                </div>
            </div>
        </section>
    );
}

export default FeaturesSection;